import { Typography } from '@mui/material';
import { CurrencyCode } from 'further-types/lp/vehicle';
import Table from 'further-ui/components/Table';
import TypographyButton from 'further-ui/components/TypographyButton';
import { ActionRefLabels } from 'further-ui/labels';
import { CalendarDay, numberToCurrencyString } from 'further-ui/utils';
import { useState } from 'react';

const actionHistoryColumns = [
  {
    key: 'date',
    label: 'Date',
    width: 140,
  },
  {
    key: 'actionRef',
    label: 'Action',
    width: 200,
  },

  {
    key: 'amountLcy',
    label: 'Funds received',
    width: 160,
  },
];

type Props = {
  baseCurrency: CurrencyCode;
  actionHistory: Array<{
    actionRef: string;
    actionId: string;
    amountLcy?: number | null;
    date: CalendarDay;
  }>;
};

const DistributableActionsHistory: React.FC<Props> = ({
  actionHistory,
  baseCurrency,
}) => {
  const [showActionHistory, setShowActionHistory] = useState(false);

  const rows = actionHistory.map((action) => ({
    id: action.actionId,
    actionRef: ActionRefLabels[action.actionRef],
    date: action.date.toReadable(),
    amountLcy: numberToCurrencyString(action.amountLcy, {
      currency: baseCurrency,
      negativeInBrackets: true,
    }),
  }));

  return (
    <>
      <Typography variant="body2">
        Click{' '}
        <TypographyButton
          variant="body2"
          text="here"
          onClick={() => setShowActionHistory(!showActionHistory)}
        />{' '}
        to {showActionHistory ? 'hide' : 'view'} your distributable transaction
        history.
      </Typography>
      {showActionHistory && (
        <Table
          scrollable
          columns={actionHistoryColumns}
          rows={rows}
          emptyMessage="No distributable transactions"
        />
      )}
    </>
  );
};

export default DistributableActionsHistory;
